<template>
  <v-card
    class="mx-auto parent-list-overflow rounded-card card-shadow"
    height="450"
    max-height="450"
  >
    <v-card-title class="headline text--primary font-weight-bold">
      Aprovação de solicitações pendentes
    </v-card-title>
    <v-card-text class="text--primary list-overflow">
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div>
        <v-list class="mt-3" v-if="!loading && aprovacoes.length">
          <template v-for="aprovacao in aprovacoes">
            <v-list-item link
                         :to="`aprovacoes-solicitacoes?id=${aprovacao.id}`"
                         :key="aprovacao.id">
              <v-list-item-content>
                <v-row dense no-gutters>
                  <v-col cols="12" sm="8">
                    {{ aprovacao.comprador.pessoa.nome }}
                  </v-col>
                  <v-col cols="12" sm="4" class="text-center">
                    <px-requisicao-urgencia :urgencia="aprovacao.urgencia"/>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`div-${aprovacao.id}`"/>
          </template>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';
import { SituacaoAprovacao } from 'px-business-components';

export default {
  data() {
    return {
      loading: false,
      aprovacoes: [],
    };
  },
  methods: {
    getAprovacoes() {
      this.loading = true;
      AprovacaoSolicitacaoService.getList({
        limit: 20,
        query: 'order by createdIn desc',
        situacao: SituacaoAprovacao.keys.PENDENTE.key,
      })
        .then(({ data }) => {
          this.aprovacoes = data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getAprovacoes();
  },
};
</script>

<style scoped>
.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 395px;
  max-height: 395px;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
